module.exports = __webpack_public_path__ + "img/notopicdata.d32d392c.svg";